import type { ArticlesSlice } from "@broadside/common";
import type { SliceProps } from "../SliceProps";
import { css, styled } from "@mui/material/styles";
import clsx from "clsx";
import { ArticleCard } from "../../components";
import { SliceTitle } from "../components/SliceTitle";


const ArticlesRoot = styled("section")(({ theme }) => css`
	max-width: ${theme.contentWidth};
	width: 100%;

	.articles {
		&--one-article {
			display: flex;
			justify-content: center;
			align-items: center;
		}
	
		&.articles--many-articles {
			display: grid;
			grid-template-columns: repeat(1, 1fr);
			gap: var(--page-pad-y);

			${theme.breakpoints.up("sm")} {
				grid-template-columns: repeat(2, 1fr);
			}
		}
	}
`);


export const Slice_ArticlesDefault = ({ slice }: SliceProps<ArticlesSlice>) => (
	<ArticlesRoot>
		<SliceTitle slice={ slice }/>
		<div className={ clsx("articles", {
			"articles--one-article": slice.articles.length === 1,
			"articles--many-articles": slice.articles.length > 1,
		}) }
		>
			{ slice.articles.map(a => (
				<ArticleCard
					article={ a }
					single={ slice.articles.length === 1 }
					key={ a.uri }
				/>
			)) }
		</div>
	</ArticlesRoot>
);
